<template>
  <div class="topic-resource">
    <!-- 筛选目录 -->
    <filtrate
      v-bind="$attrs"
      @getQuestion="getQuestion"
      :page="pagination.currentPage"
      :pageSize="pagination.pageSize"
      ref="filtrate"
      @amendPagination="amendPagination"
    />
    <div style="min-height: 500px; position: relative;">
      <div class="topic-resource__all">共{{pagination.total}}道题目</div>
    <!-- 题目列表 -->
      <div v-for="(item,index) in questionList" :key="index">
        <div class="topic-resource__card">
          <p
            class="topic-resource__card__title"
            v-for="(k, i) in item.knowledge"
            :key="i"
          >{{k.knowledge_name}}</p>
          <div class="topic-resource__card__count">
            <p v-katexHtml="item.body.content"></p>
            <img v-for="(img, i) in getImgList(item)" :key="i" :src="img.source"/>
             <div
              class="topic-resource__analysis__option"
            >
              <div
                v-for="(oitem, oindex) in item.option"
                :key="oindex"
              >
                <p>{{oitem.key}} : </p>
                <p v-katexHtml="oitem.content"></p>
                <img v-for="(oimg, i) in getImgList(oitem)" :key="i" :src="oimg.source"/>
              </div>
            </div>
          </div>
          <div class="topic-resource__card__footer">
            <div class="topic-resource__card__type">
              <span>题型:</span>
              <span>{{questionName[item.question_type]}}</span>
            </div>
            <div class="topic-resource__card__type">
              <span>难度:</span>
              <span>{{item.difficulty}}</span>
            </div>
            <!-- <div class="topic-resource__card__type">
              <span>人数:</span>
              <span>200</span>
            </div> -->
            <span class="topic-resource__card__analysis">
              <img
                src="../../images/examine-analysis.png"
                class="topic-resource__img"
                alt=""
              >
              <span
                v-if="!item.active"
                style="margin-left: 6px"
                @click="closeAnalysis(item)">收起解析</span>
              <span
                v-else
                style="margin-left: 6px"
                @click="openAnalysis(item)">展开解析</span>
            </span>
            <span
              class="topic-resource__card__feedback"
              @click="submitAnalysis(item.question_uuid)"
              v-if="!isPad"
            >
              <img
                src="../../images/feedback.png"
                class="topic-resource__img"
                alt=""
              >
              反馈
            </span>
          </div>
          <img src="../../images/footer-left.png" class="topic-resource__left">
          <img src="../../images/footer-right.png" class="topic-resource__right">
        </div>
        <!-- 解析 -->
        <div
          class="topic-resource__analysis"
          v-if="!item.active">
          <div class="topic-resource__analysis__answer">
            <span>正确答案:</span>
            <span
              v-for="(aitem, aindex) in item.answer"
              :key="aindex"
              class="topic-resource__analysis__content"
              v-katexHtml="aitem[0].content"
            ></span>
          </div>
          <div class="topic-resource__analysis__boundary"></div>
          <div class="topic-resource__analysis__text" v-if="item.analyze[0]">
            <span style="min-width: 110px">文字解析:</span>
            <span
              v-for="(zitem, zindex) in item.analyze[0]"
              :key="zindex"
              class="topic-resource__analysis__tc"
            >
              <span v-katexHtml="zitem.content"></span>
              <img v-for="(zimg, i) in getImgList(zitem)" :key="i" :src="zimg.source"/>
            </span>
          </div>
          <div :class="{'topic-resource__analysis__boundary': videoType(item.analyze[0])}"></div>
          <div
            class="topic-resource__analysis__video"
            v-if="videoType(item.analyze[0])"
          >
            <span style="min-width: 110px">视频解析</span>
            <span
              class="topic-resource__analysis__video__type"
              :key="vindex"
              @click="videoOpen(item.analyze[0][0].video_data[0].source)"
            >
              <p>{{videoManage(item.analyze[0][0].video_data[0].source)}}</p>
            </span>
          </div>
        </div>
      </div>
      <div v-if="questionList.length < 1" class="empty">
        <img src="../../images/emptyType.png" alt="">
      </div>
    </div>
      <!-- 分页 -->
    <el-pagination
      background
      layout="total, sizes, prev, pager, next"
      :total="pagination.total"
      :page-size="pagination.pageSize"
      :page-sizes="[10, 20, 50]"
      :current-page="pagination.currentPage"
      @size-change="sizeChange"
      @current-change="currentChange"
    >
    </el-pagination>
    <!-- 反馈弹框 -->
    <analysis-dialog
      :centerDialogVisible.sync="centerDialogVisible"
      :questionUUid="questionUUid"
    />
    <!-- 视频弹框 -->
    <video-dialog
      :dialogVisible.sync="dialogVisible"
      :videoUrl="videoUrl"
      />
  </div>
</template>

<script>
/* eslint-disable */
import _ from 'lodash';
import filtrate from './filtrate.vue';
import analysisDialog from './analysis-dialog.vue';
import videoDialog from './video-dialog.vue';

export default {
  name: 'TopicResource',
  components: {
    filtrate,
    analysisDialog,
    videoDialog
  },
  data() {
    return {
      questionList: [],
      isPad: this.$route.query.spad,
      centerDialogVisible: false,
      analysisType: false,
      analysisNumber: 0,
      oneType: false,
      pagination: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      dialogVisible: false,
      videoUrl: '',
      questionUUid: '',
      questionName: {
        1: '单选题',
        2: '多选题',
        3: '填空题',
        4: '判断题'
      },
    };
  },
  computed: {
    videoType() {
      return function(val) {
        if (val) {
          val.some(item => {
            item.video_data.length > 0
          })
        }
      }
    },
    pageCount() {
      return Math.ceil(this.pagination.total / this.pagination.pageSize)
    },
    videoTime() {
      return function (url) {
        const audio = new Audio(url);
      // 元数据已加载
      audio.addEventListener('loadedmetadata', () => {
        // this.duration = audio.duration;
        if (audio.duration < 60) {
          this.duration = `00:${audio.duration}`;
          return;
        }
        let m = Math.floor(audio.duration / 60);
        let s = Math.floor(audio.duration % 60);
        s = s < 10 ? `0${s}` : s;
        m = m < 10 ? `0${m}` : m;
        return `${m} : ${s}`;
      });
      }
    },
  },
  mounted() {
    // document.getElementsByClassName('el-pagination__jump')[0].childNodes[0].nodeValue = '跳至';
  },
  methods: {
    getImgList(item) {
      return _.get(item, 'body.img_data') ||  _.get(item, 'img_data') || [] ;
    },
    submitAnalysis(uuid) { // 反馈
      this.questionUUid = uuid;
      this.centerDialogVisible = true;
    },
    videoOpen(val) {
      this.dialogVisible = true;
      this.videoUrl = val;
    },
    amendPagination(page, size) {
      this.pagination.currentPage = page;
      this.pagination.pageSize = size;
    },
    getQuestion(val) { // 渲染列表
      this.pagination.total = val.total;
      this.questionList = val.data;
      this.questionList.forEach(item => {
        this.$set(item, 'active', true)
      })
    },
    sizeChange(v) { // 每页条数
      this.pagination.pageSize = v;
    },
    currentChange(v) { // 当前页
      this.pagination.currentPage = v;
    },
    openAnalysis(item) {
      item.active = false;
    },
    closeAnalysis(item) {
      item.active = true;
    },
  },
};
</script>

<style lang="scss" scoped>
  .topic-resource {
    // width: 860px;
    font-size: 14px;
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0px 2px 16px 0px rgba(220, 225, 236, 0.5);
    & /deep/ .el-input--mini {
      margin-left: 80px;
    }
    &__img {
      width: 12px;
      height: 12px;
    }
    &__all {
      position: absolute;
      right: 0;
      top: -30px;
    }
    &__card {
      position: relative;
      min-height: 100px;
      margin-left: 28px;
      margin-top: 28px;
      background: #FFFFFF;
      padding: 22px 0;
      background-size: 100% 48px;
      border: 4px solid rgba(118, 194, 255, 0.14);
      border-radius: 12px;
      &__title {
        display: inline-block;
        min-width: 89px;
        padding: 5px;
        margin-right: 5px;
        margin-left: 25px;
        line-height: 24px;
        text-align: center;
        background: #F0F2F5;
        border-radius: 3px;
        border: 1px solid #D7DFEC;
      }
      &__count {
        margin-top: 16px;
        min-height: 50px;
        width: 584px;
        font-size: 15px;
        padding: 0 25px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #111F2C;
        line-height: 21px;
      }
      &__footer {
        padding: 0 25px;
        line-height: 40px;
        position: relative;
        bottom: -23px;
        background-color: #F5F9FF;
        border-radius: 0 0 12px 12px ;
      }
      &__type {
        display: inline-block;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #5A5E66;
        line-height: 20px;
        margin-right: 48px;
      }
      &__feedback {
        float: right;
        margin-right: 44px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1989FA;
      }
      &__analysis {
        float: right;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1989FA;
      }
    }
    &__paging {
      position: relative;
      left: 80px;
      top: -28px;
    }
    &__analysis {
      margin-left: 48px;
      margin-right: 20px;
      background: #FFFFFF;
      border-radius: 0px 0px 12px 12px;
      border: 4px solid rgba(118, 194, 255, .14);
      border-top: none;
      padding: 10px 22px;
      padding-bottom: 1px;
      &__option {
        div {
          display: inline-block;
          font-size: 15px;
          // font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          margin: 0  20px;
          p {
            display: inline-block;
            margin-right: 5px;
          }
        }
      }
      &__answer {
        font-size: 15px;
        min-width: 120px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 53px;
      }
      &__content {
        position: relative;
        left: 40px;
        margin-right: 5px;
        color: #7DCB56;
      }
      &__boundary {
        border: 1px dotted #DCE1EB
      }
      &__text {
        display: flex;
        flex-direction: column;
        font-size: 15px;
        margin-top: 20px;
        margin-bottom: 20px;
        justify-content: flex-start;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
      }
      &__video {
        display: flex;
        font-size: 15px;
        margin-top: 20px;
        margin-bottom: 20px;
        justify-content: flex-start;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        span {
          vertical-align: baseline;
          margin-right: 5px;
        }
        &__type {
          display: inline-block;
          width: 84px;
          height: 28px;
          background: no-repeat url("../../images/class_video.png") 1px center #FFA82D;
          border-radius: 14px;
          text-align: center;
          color: #fff;
          line-height: 28px;
          p {
            text-indent: 1em;
          }
        }
      }
    }
    & /deep/ .el-pagination {
      margin-top: 20px;
      display: flex;
      // position: absolute;
      margin-left: 30px;
      width: calc(100% - 64px);
      bottom: 30px;
      left: 32px;
      & .btn-prev {
        margin-left: auto;
      }
      & .el-select{
        left: -55px;
      }
    }
    &__left {
      width: 27px;
      position: absolute;
      left: -1px;
      bottom: 0px;
      border-radius: 0 0 0 12px;
    }
    &__right  {
      width: 27px;
      position: absolute;
      right: -1px;
      bottom: -2px;
      border-radius: 0 0 12px 0
    }
  }
  .empty {
      img {
        width: 209px;
        height: 147px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 30px;
      }
    }
</style>
